import { styled, component } from '../../../utils/style';
import { StyleColor } from '../../../utils/styles-constants';

interface StyledLeftSideMenuProps {
	isOpen: boolean;
}

export const StyledLeftSideMenu = styled<StyledLeftSideMenuProps>()(component.div, 'StyledLeftSideMenu')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: ${ props => props.isOpen ? 0 : '-300px'};
	margin: 0;
	width: 300px;
	background-color: ${StyleColor.Grey50};
	overflow-x: hidden;
	overflow-y: auto;
	padding: 0;
	transition: left 0.2s;
	z-index: 11;
	color: ${StyleColor.Grey500};
`;

export const HeaderMenuItem = styled()(component.div, 'HeaderMenuItem')`
	color: ${StyleColor.Grey100};
	background-color: ${StyleColor.Grey600};
	text-transform: uppercase;
	padding: 10px 15px;
	font-size: 10px;
`;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/styles.ts